<template>
  <vx-card>
    <heading :size="$route.params.id ? 'h2' : 'h1'" style-size="h4" class="mb-5"
      >You don't have an active Work Experience</heading
    >

    <p class="mb-5">Some intro text here.</p>
    <router-link
      to="/student/available-experiences"
      class="no-underline btn btn-primary btn-size-medium includedIcon"
    >
      <folder-plus-icon />Start a New Experience
    </router-link>
  </vx-card>
</template>

<script>
import { FolderPlusIcon } from 'vue-feather-icons';

export default {
  components: {
    FolderPlusIcon,
  },
};
</script>
